import jenny_hayes from "../images/feed/jenny_hayes.jpg"
import fiona_wood from "../images/feed/fiona_wood.jpg"
import jeffrey_rosenfeld from "../images/feed/jeffrey_rosenfeld.jpg"
import rob_moodie from "../images/feed/rob_moodie.jpg"
import maithri_goonetilleke from "../images/feed/maithri_goonetilleke.jpg"
import chatu_yapa from "../images/feed/chatu_yapa.jpg"
import sally_graddon from "../images/feed/sally_graddon.jpg"
import jason_lam from "../images/feed/jason_lam.jpg"
import steve_trumble from "../images/feed/steve_trumble.jpg"
import ranjana_srivastava from "../images/feed/ranjana_srivastava.jpg"
import mark_cook from "../images/feed/mark_cook.jpg"
import nick_carr from "../images/feed/nick_carr.jpg"
import peter_choong from "../images/feed/peter_choong.jpg"
import hon_weng_chong from "../images/feed/hon_weng_chong.jpg"
import joe_rotella from "../images/feed/joe_rotella.jpg"
import olivia_lesslar from "../images/feed/olivia_lesslar.jpg"
import rebecca_stewart from "../images/feed/rebecca_stewart.jpg"
import tilman_ruff from "../images/feed/tilman_ruff.jpg"
import glenn_begley from "../images/feed/glenn_begley.jpg"
import anita_elias from "../images/feed/anita_elias.jpg"
import ginni_mansberg from "../images/feed/ginni_mansberg.jpg"
import rinaldo_bellomo from "../images/feed/rinaldo_bellomo.jpg"
import frank_gaillard from "../images/feed/frank_gaillard.jpg"
import grace_dugan from "../images/feed/grace_dugan.jpg"
import tal_rapke from "../images/feed/tal_rapke.jpg"
import sally_bell from "../images/feed/sally_bell.jpg"
import jonathan_king from "../images/feed/jonathan_king.jpg"
import helen_malcolm from "../images/feed/helen_malcolm.jpg"
import peter_morley from "../images/feed/peter_morley.jpg"
import frank_oberklaid from "../images/feed/frank_oberklaid.jpg"
import kelley_withy from "../images/feed/kelley_withy.jpg"
import joseph_proietto from "../images/feed/joseph_proietto.jpg"
import andrew_pattison from "../images/feed/andrew_pattison.jpg"
import michael_bonning from "../images/feed/michael_bonning.jpg"
import yvonne_ho from "../images/feed/yvonne_ho.jpg"
import adir_shiffman from "../images/feed/adir_shiffman.jpg"
import louise_teo from "../images/feed/louise_teo.jpg"
import jim_black from "../images/feed/jim_black.jpg"
import brendan_nelson from "../images/feed/brendan_nelson.jpg"
import yumiko_kadota from "../images/feed/yumiko_kadota.jpg"
import dr_karl from "../images/feed/dr_karl.jpg"
import patrick_mcgorry from "../images/feed/patrick_mcgorry.jpg"
import raffy_halim from "../images/feed/raffy_halim.jpg"
import renee_lim from "../images/feed/renee_lim.jpg"
import richard_di_natale from "../images/feed/richard_di_natale.jpg"
import ashe_coxon from "../images/feed/ashe_coxon.jpg"
import simon_judkins from "../images/feed/simon_judkins.jpg"
import linny_kimly_phuong from "../images/feed/linny_kimly_phuong.jpg"
import tim_read from "../images/feed/tim_read.jpg"
import chandrashan_perera from "../images/feed/chandrashan_perera.jpg"
import kate_tyson from "../images/feed/kate_tyson.jpg"
import exam_edition_1 from "../images/feed/exam_edition_1.jpg"
import exam_edition_2 from "../images/feed/exam_edition_2.jpg"
import michael_levitt from "../images/feed/michael_levitt.jpg"
import murray_esler from "../images/feed/murray_esler.jpg"
import matthew_chan from "../images/feed/matthew_chan.jpg"
import ian_harris from "../images/feed/ian_harris.jpg"
import peter_blamey from "../images/feed/peter_blamey.jpg"
import june_brundell from "../images/feed/june_brundell.jpg"
import skye_kinder from "../images/feed/skye_kinder.jpg"
import bradley_frew from "../images/feed/bradley_frew.jpg"
import melanie_tan from "../images/feed/melanie_tan.jpg"
import brian_spain from "../images/feed/brian_spain.jpg"
import evelyn_chan from "../images/feed/evelyn_chan.jpg"
import katie_allen from "../images/feed/katie_allen.jpg"
import roy_robins from "../images/feed/roy_robins.jpg"
import marian_dover from "../images/feed/marian_dover.jpg"
import jan_coles from "../images/feed/jan_coles.jpg"
import thailand_covidsation from "../images/feed/thailand_covidsation.jpg"
import melissa_kang from "../images/feed/melissa_kang.jpg"
import bronwyn_king from "../images/feed/bronwyn_king.jpg"
import allison_hempenstall from "../images/feed/allison_hempenstall.jpg"
import david_lam from "../images/feed/david_lam.jpg"
import robbie_gillies from "../images/feed/robbie_gillies.jpg"
import khoa_cao from "../images/feed/khoa_cao.jpg"

const feed_images_array = [
    jenny_hayes,
    fiona_wood,
    jeffrey_rosenfeld,
    rob_moodie,
    maithri_goonetilleke,
    chatu_yapa,
    sally_graddon,
    jason_lam,
    steve_trumble,
    ranjana_srivastava,
    mark_cook,
    nick_carr,
    peter_choong,
    hon_weng_chong,
    joe_rotella,
    olivia_lesslar,
    rebecca_stewart,
    tilman_ruff,
    glenn_begley,
    anita_elias,
    ginni_mansberg,
    rinaldo_bellomo,
    frank_gaillard,
    grace_dugan,
    tal_rapke,
    sally_bell,
    jonathan_king,
    helen_malcolm,
    peter_morley,
    frank_oberklaid,
    kelley_withy,
    joseph_proietto,
    andrew_pattison,
    michael_bonning,
    yvonne_ho,
    adir_shiffman,
    louise_teo,
    jim_black,
    brendan_nelson,
    yumiko_kadota,
    dr_karl,
    patrick_mcgorry,
    raffy_halim,
    renee_lim,
    richard_di_natale,
    ashe_coxon,
    simon_judkins,
    linny_kimly_phuong,
    tim_read,
    chandrashan_perera,
    kate_tyson,
    exam_edition_1,
    exam_edition_2,
    michael_levitt,
    murray_esler,
    matthew_chan,
    ian_harris,
    peter_blamey,
    june_brundell,
    skye_kinder,
    bradley_frew,
    melanie_tan,
    brian_spain,
    evelyn_chan,
    katie_allen,
    roy_robins,
    marian_dover,
    jan_coles,
    thailand_covidsation,
    melissa_kang,
    bronwyn_king,
    allison_hempenstall,
    david_lam,
    robbie_gillies,
    khoa_cao,
]

export default feed_images_array